export default "__VITE_ASSET__TDpfotq2__"